import { render } from "./agent-region.vue?vue&type=template&id=6663713e"
import script from "./agent-region.js?vue&type=script&lang=js"
export * from "./agent-region.js?vue&type=script&lang=js"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__